


















// @ is an alias to /src
import Vue from 'vue';
import ApiRequest from '@/util/apiRequest';

import { API_TAG_QUERY } from '../../util/config';

export default Vue.extend({
  name: 'home',
  data() {
    return {
      tags: undefined,
      tagSearch: '',
      lastTagQuery: undefined,
    };
  },
  components: {
  },
  methods: {
    async runTagSearch() {
      clearTimeout(this.$data.tagDebounce);
      this.$data.tagDebounce = setTimeout(async () => {
        if (this.$data.lastTagQuery !== this.$data.tagSearch) {
          if (this.$data.tagSearch.length < 2) {
            this.$data.tags = undefined;
            return;
          }
          this.$data.lastTagQuery = this.$data.tagSearch;
          const response = await ApiRequest.Get(API_TAG_QUERY
            + encodeURIComponent(this.$data.tagSearch));
          this.$data.tags = response;
        }
      }, 600);
    },
  },
  watch: {
    tagSearch: 'runTagSearch',
  },
  mounted() {
  },
});
